import { isSimplifiedTransactionType } from "../resources/common/isSimplifiedTransactionType";
import { OverallStatus } from "./derivePeppolStatus";

export const canDownloadDocumentPdf = (row) => {
  if (isSimplifiedTransactionType(row?.transaction_type)) {
    return true;
  }

  return (
    row?.meta_info?.peppol_status?.overall_status === OverallStatus.APPROVED
  );
};
